import { render } from "./TutorialCard.vue?vue&type=template&id=72066b48&scoped=true"
import script from "./TutorialCard.vue?vue&type=script&lang=js"
export * from "./TutorialCard.vue?vue&type=script&lang=js"

import "./TutorialCard.vue?vue&type=style&index=0&id=72066b48&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72066b48"]])

export default __exports__